export class SelectedOption {
  constructor(
    public id: string,
    public title: string
  ) {}
}
